import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-python';
import 'ace-builds/src-noconflict/theme-monokai';

import { TimelineItem } from '@yaradigitallabs/ahua-react';
import { copyToClipboard } from '@/utils/clipboard';
import { config } from '@/config';

import { Colors } from '../../../../../public/GlobalTokens';
import { showCopyToast } from '../../utils/helpers';
import { GuidelineDialog } from './GuidelineDialog';

// Example formula code block as a constant
const formulaExample = `from imports import *\nfrom staging import *\nfrom storage import *\nfrom util import *\n\ndef fetch_tag_data(tag_name, timeseries_id):\n  data_model = {\n    "tag_name": tag_name,\n    "timeseries_id": timeseries_id\n    # others\n  }\n  return get_data(source=<config>/parsable, data_model=data_model)\n\ndef calculate():\n  tag_data_SENSOR1 = fetch_tag_data("SENSOR1_TAG", "sensor1-uuid-1234")\n  tag_data_SENSOR2 = fetch_tag_data("SENSOR2_TAG", "sensor2-uuid-5678")\n  return tag_data_SENSOR1 + tag_data_SENSOR2\n\nretval = calculate()\nprint(retval)`;

const handleCopy = async (
  e: React.MouseEvent<HTMLButtonElement, MouseEvent>
) => {
  try {
    const success = await copyToClipboard(formulaExample);
    const container = e.currentTarget.parentElement as HTMLDivElement;
    if (container) {
      if (success) {
        showCopyToast(container, 'Copied', false);
      } else {
        showCopyToast(container, 'Copy failed', true);
        console.warn('Failed to copy to clipboard');
      }
    }
  } catch (error) {
    console.error('Copy operation failed:', error);
    const container = e.currentTarget.parentElement as HTMLDivElement;
    if (container) {
      showCopyToast(container, 'Copy error', true);
    }
  }
};

// FormulaGuideline: Shows formula writing rules and best practices in a dialog
export const FormulaGuideline = () => (
  <GuidelineDialog
    title="Formula Guideline"
    icon="Info"
    iconSize="xs"
    triggerTitle="Formula Guideline"
    content={
      <div>
        <div className="flex items-center justify-between">
          Formula Example:
          <TimelineItem>
            <TimelineItem.IconButton
              icon="Copy"
              size="xs"
              title="Copy Formula Example"
              type="filled"
              onClick={handleCopy}
            />
          </TimelineItem>
        </div>
        <AceEditor
          mode="python"
          theme="monokai"
          value={formulaExample}
          highlightActiveLine={false}
          width="700px"
          name="formula-code"
          editorProps={{ $blockScrolling: true }}
          wrapEnabled={true}
          minLines={5}
          maxLines={formulaExample.length}
          setOptions={{
            showPrintMargin: false,
            useWorker: false,
            wrap: false,
          }}
          className="my-2 pl-2"
          readOnly
        />
      </div>
    }
    helperText={
      <>
        Please adhere to formula writing{' '}
        <a
          href={config.formulaGuidelineUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="underline"
          style={{ color: Colors.ahua.blue.scale50 }}
        >
          guidelines
        </a>
        .
      </>
    }
  />
);
